/**
 * The takeover's two columns: the question and its info panel, set against
 * the content's far edge.
 */
const TAKEOVER_COLUMNS_CLASS_NAME =
  "md:grid-cols-[minmax(0,28rem)_minmax(0,21.5rem)] md:items-start md:justify-between";

/**
 * The progress indicator and the question share the first column, so the
 * bar keeps its width while steps change. The column gap keeps the columns
 * apart once the section is too narrow for both at full width; the step's
 * subgrid inherits it.
 */
const TAKEOVER_QUESTION_COLUMN_GRID_CLASS_NAME = `md:grid ${TAKEOVER_COLUMNS_CLASS_NAME} md:gap-x-10`;

/** The step's question and panel join the question-column grid's tracks. */
const TAKEOVER_QUESTION_COLUMN_STEP_CLASS_NAME =
  "md:col-span-2 md:grid md:grid-cols-subgrid";

export {
  TAKEOVER_COLUMNS_CLASS_NAME,
  TAKEOVER_QUESTION_COLUMN_GRID_CLASS_NAME,
  TAKEOVER_QUESTION_COLUMN_STEP_CLASS_NAME,
};
